import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DonorsByCollectionSiteChart from "./DonorsByCollectionSiteChart";

// Static data for donors by collection site
const STATIC_COLLECTION_SITE_DATA = {
  fixedSite: 1250,
  mobileDrive: 890,
  hospital: 560,
};

const DonorsByCollectionSiteWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Donors by Collection Site")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <DonorsByCollectionSiteChart data={STATIC_COLLECTION_SITE_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DonorsByCollectionSiteWrapper;
